import { render, staticRenderFns } from "./record-video.vue?vue&type=template&id=f532e042&"
import script from "./record-video.js?vue&type=script&lang=js&"
export * from "./record-video.js?vue&type=script&lang=js&"
import style0 from "./record-video.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports